export interface AuthState {
  user: Auth | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean
  myDataHasBeenExtracted: "extracting" | "extracted" | null
}

// Legacy AI types

export interface Question {
  id: string
  legacyId: string
  category: QuestionCategory
  question: string
  answer: string
  createdAt: string
  updatedAt: string
}

export enum QuestionCategory {
  // PERSONAL = "personal",
  // FAMILY = "family",
  // CAREER = "career",
  // HOBBIES = "hobbies",
  // BELIEFS = "beliefs",
  // MEMORIES = "memories",
  // WISDOM = "wisdom",
  // HUMOR = "humor",
  // VALUES = "values",
  // EXPERIENCES = "experiences",
  AGREEABLENESS = "agreeableness",
  CONSCIENTIOUSNESS = "conscientiousness",
  EXTRAVERSION = "extraversion",
  NEUROTICISM = "neuroticism",
  OPENNESS = "openness",
}

export interface Conversation {
  id: string
  assistant_id: string
  type: ConversationType
  content: string
  audioUrl?: string
  videoUrl?: string
  duration?: number
  createdAt: string
}

export enum ConversationType {
  TEXT = "text",
  AUDIO = "audio",
  VIDEO = "video",
  IMAGE = "image",
}

export interface Message {
  id: string
  legacyId: string
  title: string
  content: string
  type: MessageType
  scheduledDate?: string
  isDelivered: boolean
  createdAt: string
}

export enum MessageType {
  LETTER = "letter",
  VIDEO_MESSAGE = "video_message",
  AUDIO_MESSAGE = "audio_message",
  BIRTHDAY = "birthday",
  ANNIVERSARY = "anniversary",
  SPECIAL_OCCASION = "special_occasion",
}

export interface ChatMessage {
  id: string
  legacyId: string
  sender: "user" | "legacy"
  content: string
  timestamp: string
  isTyping?: boolean
}

// API Response types
export interface ApiResponse<T> {
  success: boolean
  data: T
  message?: string
  error?: string
}

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  limit: number
  totalPages: number
}

// Form types
export interface LoginForm {
  email: string
  password: string
}

export interface RegisterForm {
  name: string
  email: string
  password: string
  password_confirmation: string
}

export interface ForgotPasswordForm {
  email: string
}

export interface ResetPasswordForm {
  token: string
  password: string
  password_confirmation: string
}

// UI State types
export interface UIState {
  sidebarOpen: boolean
  theme: "light" | "dark"
  loading: boolean
  notifications: Notification[]
}

export interface Notification {
  id: string
  type: "success" | "error" | "warning" | "info"
  title: string
  message: string
  duration?: number
  createdAt: string
  isRead?: boolean
  userId?: number
  legacyId?: string
  actionUrl?: string
}

export interface Email {
  id: string
  from: string
  fromName: string
  to: string
  subject: string
  body: string
  isRead: boolean
  isImportant: boolean
  isStarred: boolean
  hasAttachments: boolean
  attachments: EmailAttachment[]
  receivedAt: string
  folder: "inbox" | "sent" | "drafts" | "trash" | "spam"
  labels: string[]
  threadId: string
}

export interface EmailAttachment {
  name: string
  size: string
  type: string
}

export interface Auth {
  id: number
  name: string
  email: string
  email_verified_at: string
  rol: string
  date_register: string
  last_login: string
  age: number | null
  avatar_path: string | null
  alias: string | null
  country: string | null
  language: string | null
}

export interface LoginResponse {
  token: string
  type: string
  user: Auth
}
